import { initColorSelect, doAjax, updateTableValue, initStitchesBackgroundColorListeners, initRedPointLogic } from './helper'
import { loadAlreadyCustomizedOptions, replaceImage } from './interior-general-logic'


const initInteriorFootmatsCustomizing = () => {
	initColorSelect()
	const is0TFQ7Q9 = aeo['configuration']['0TF_Q7Q9'] === true
	const loadOptions = (is0TFQ7Q9) ? {} : {}
	loadAlreadyCustomizedOptions(() => {}, loadOptions)
	const piping = 'piping'
	const stitchPiping = 'stitchPiping'
	const carpet = 'carpet'
	const footmat = 'footmat'
	const footmatBiese = 'footmatBiese'
	const footmatEmbossing = 'footmatEmbossing'	

	initStitchesBackgroundColorListeners(getDotIdWithComponent(piping), getDotIdWithComponent(stitchPiping))
	initRedPointLogic(piping, getDotIdWithComponent(piping), setImage)
	initRedPointLogic(carpet, getDotIdWithComponent(carpet), setImage)
	initRedPointLogic(footmat, getDotIdWithComponent(footmat), setImage)
	initRedPointLogic(footmatBiese, getDotIdWithComponent(footmatBiese), setImage)
	initRedPointLogic(stitchPiping, getDotIdWithComponent(stitchPiping), setImage)
	initRedPointLogic(footmatEmbossing, getDotIdWithComponent(footmatEmbossing), setImage)
}

/**Returns the DOT ID for the component on params */
function getDotIdWithComponent(component) {
	switch (component) {
		case 'piping': return 'dot_keder'
		case 'stitchPiping': return 'dot_footmat-kontrastnaht'
		case 'carpet': return 'dot_carpet'
		case 'footmat': return 'dot_footmatColor'
		case 'footmatBiese': return 'dot_biese'
		case 'footmatEmbossing': return 'dot_embossing'		
		default: break;
	}
}

function setImage(component, colorCode) {	
	const carModel = document.querySelector("input[name=carmodel]").value;
	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value;

	
	const setYSQ = aeo['configuration']['YSQ'] === true
	const setYSQ_Q7Q8 = aeo['configuration']['YSQ_Q7Q8'] === true
	const setYSR_A6 = aeo['configuration']['YSR_A6'] === true
	const setYSR_Q7Q8 = aeo['configuration']['YSR_Q7Q8'] === true
	const setYSR = aeo['configuration']['YSR'] === true
	const setYTU = aeo['configuration']['YTU'] === true
	const setYTU_RS6RS7 = aeo['configuration']['YTU_RS6RS7'] === true
	const setYTU_Q7Q8 = aeo['configuration']['YTU_Q7Q8'] === true
	const setYSR_A8 = aeo['configuration']['YSR_A8'] === true
	const set0TF_Q6etron = aeo['configuration']['0TF'] === true
	const set0TF_A5 = aeo['configuration']['0TF_A5'] === true
	const set0TF_A6etron = aeo['configuration']['0TF_A6etron'] === true
	const set0TF_A7C9etron = aeo['configuration']['0TF_A6_C9'] === true
	const set0TF_Q7Q9 = aeo['configuration']['0TF_Q7Q9'] === true

	if (setYSQ) {
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YSQ_front_view'][colorCode]
		var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_back_view'][colorCode]
	} else if (setYSR_A6) {		
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YSR_A6_front_view'][colorCode]
		var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_back_view'][colorCode]
	} else if  (setYTU_RS6RS7) {		
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YSR_A6_front_view'][colorCode]
		//if (component != 'footmatEmbossing'){
			var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_back_view'][colorCode]
		//}

	} else if (setYSR) { //e-tron
		const frontviewPath = component == "piping" ? 'piping_front_view' : 'stitch_piping_front_view'
		const backviewPath = component == "piping" ? 'piping_back_view' : 'stitch_piping_back_view'
		var imageSourceFront = aeo['images'][frontviewPath][colorCode]
		var imageSourceBack = aeo['images'][backviewPath][colorCode]

	} else if (setYTU) { //e-tron RS
		/*
		const frontviewPath = component == "piping" ? 'piping_front_view' : 'stitch_piping_front_view'
		const backviewPath = component == "piping" ? 'piping_back_view' : 'stitch_piping_back_view'
		var imageSourceFront = aeo['images'][frontviewPath][colorCode]
		var imageSourceBack = aeo['images'][backviewPath][colorCode]
		*/

		if (component ==  "piping") {
			imageSourceFront = aeo['images']['piping_front_view'][colorCode]
			imageSourceBack = aeo['images']['piping_back_view'][colorCode]
		}
		if (component ==  "stitchPiping") {
			imageSourceFront = aeo['images']['stitch_piping_front_view'][colorCode]
			imageSourceBack = aeo['images']['stitch_piping_back_view'][colorCode]
		}
		if (component ==  "footmatEmbossing") {
			imageSourceFront = aeo['images']['footmatEmbossing_YTU_front_view'][colorCode];
			imageSourceBack = "";
		}

	} else if (setYSR_Q7Q8) {		
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YSR_Q7Q8_front_view'][colorCode]
		var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_YSR_Q7Q8_back_view'][colorCode]

	} else if (setYSQ_Q7Q8) {		
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YSQ_Q7Q8_front_view'][colorCode]
		var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_YSQ_Q7Q8_back_view'][colorCode]

	} else if (setYTU_Q7Q8) {		
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YTU_Q7Q8_front_view'][colorCode]
		var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_YTU_Q7Q8_back_view'][colorCode]

	} else if (setYSR_A8) {		
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YSR_A8_front_view'][colorCode]
		var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_YSR_A8_back_view'][colorCode]
		
	} else if (set0TF_Q6etron) {		
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_0TF_front_view'][colorCode]
		if (frontSeatModel != 'Q4Q_AU41X_PERF' && component != 'footmatEmbossing') {
			var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_0TF_back_view'][colorCode]
		}
		if (frontSeatModel == 'Q4Q_AU41X_PERF' && component != 'footmatEmbossing') { // SQ6 etron Performance
			imageSourceBack = aeo['images'][component + '_' + frontSeatModel + '_' + backSeatModel + '_0TF_back_view'][colorCode]
		}

	} else if (set0TF_A5) {		
		if (carModel == 46 || carModel == 47) {
			console.log("component: " + component)
			var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_0TF_A5_RS5_front_view'][colorCode]
			if (component !=  "footmatEmbossing") {
				var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_0TF_A5_RS5_back_view'][colorCode]
			}
		} else {
			var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_0TF_A5_front_view'][colorCode]
			var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_0TF_A5_back_view'][colorCode]	
		}			
	} else if (set0TF_A6etron) {		
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_0TF_A6_etron_front_view'][colorCode]
		var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_0TF_A6_etron_back_view'][colorCode]	
	
	} else if (set0TF_A7C9etron) {		
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_0TF_A6_C9_front_view'][colorCode]
		var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_0TF_A6_C9_back_view'][colorCode]	
	
	} else if (set0TF_Q7Q9) {		
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_0TF_Q7Q9_front_view'][colorCode]
		var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_0TF_Q7Q9_back_view'][colorCode]	
		if (carModel == 118 || carModel == 119 || carModel == 120) {
			imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_0TF_Q9_back_view'][colorCode]	
		}
	}
	
	
	replaceImage(imageSourceFront, component, 'car_frontseat')
	replaceImage(imageSourceBack, component, 'car_backseat')
	
	updateTableValue(component, colorCode, 'interior-footmat-components')
	doAjax({
		'interior_component': component,
		'color': colorCode,
		'src': imageSourceFront
	})
}

export { initInteriorFootmatsCustomizing };